import { AttachmentsPermissions } from './attachments.permissions';

export class UtilityManagementPermissions {
    static Attachments = AttachmentsPermissions?.Permissions;
}

export function getUtilityManagementModuleName() {
    return 'UtilityManagement';
}
